import styled, { css } from 'styled-components';
import { theme } from 'antd';

const { defaultAlgorithm, defaultSeed } = theme;

const mapToken = defaultAlgorithm(defaultSeed);

export const FormItemWithPlaceholderDropdownStyled = css`

    .form-item--full-width-label {
        label {
            width: 100% !important;
        }
    }

    .full-width-flex {
        display: flex !important;
        width: 100% !important;
    }

    .placeholder-dropdown {
        /* For compact dropdown - many items + has groups ==> smaller size */
        &.has-grouping {
            .ant-dropdown-menu-item {
                padding: 4px 20px !important;
            }
            
            .ant-dropdown-menu-title-content {
                font-size: 13px;
            }

            .ant-dropdown-menu {
                max-height: 55vh;
                overflow-y: auto;
            }

            .ant-dropdown-menu-item-group-title {
                font-size: 12px;
                color: rgba(0, 0, 0, 45%);
                cursor: default;
            }

            .ant-dropdown-menu-item-group-list {
                padding: 0;
                margin: 0 !important;

                .ant-dropdown-menu-item {
                    padding-inline-start: 24px !important;
                }
            }

            /* Nested groups inside another group */
            .ant-dropdown-menu-item-group .ant-dropdown-menu-item-group {
                padding-left: revert !important;
                margin-left: 8px !important;

                /* Recursive nested groups */
                .ant-dropdown-menu-item-group-list {
                    padding: revert;
                    margin-left: -36px !important;

                    .ant-dropdown-menu-item {
                        padding: 4px 20px !important;
                        padding-inline-start: revert !important;
                    }
                }
            }
        }
    }
`;

export const Styled = styled.div`

    &.full-width-label {
        display: flex;
        flex: 1 0 auto;
        justify-content: flex-end;
        color: rgba(0,0,0,50%);
    }

    .placeholder-dropdown__menu {
        min-width: auto;
        background: grey;
    }

    .disabled {
        cursor: not-allowed;
    }

    .placeholder-span {
        .icon {
            font-size: 14px;
        }

        .bordered-label {
            width: fit-content;
            padding: 2px 10px;
            font-size: 12px;
            color: #000000d9;
            background-color: #f0f0f0;
            border-radius: 4px;
        }

        &.icon-in-input {
            position: absolute;
            top: 4px;
            right: 18px;
        }

        &.disabled {
            pointer-events: none;
            cursor: not-allowed;
            background: ${mapToken.colorBackgroundDisabled};

            .bordered-label {
                color: ${mapToken.colorTextQuaternary};
            }
        }
    }
`;
